/**
 * Composed Chart Axis Type enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum COMPOSED_CHART_AXIS_TYPE {
	VALUE = "value",
	CATEGORY = "category",
	DATETIME = "datetime"
}

export const COMPOSED_CHART_AXIS_TYPE_default: keyof typeof COMPOSED_CHART_AXIS_TYPE = "VALUE";
